import React, { useState, useEffect } from 'react';
import { Box, FormControl } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../assets/logo_LemoCrane.png';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import './navbar.css';
import { apiRequest } from '../../helpers/apiRequest';
import { useAlert } from '../../utils';
import { updateMenuProgram } from '../../store/slices/authSlice';
import Form from 'react-bootstrap/Form';
import MenuIcon from './MenuIcon';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useNavigate } from 'react-router-dom';
import { openAlert } from '../AlertDialog';
import { logoutUser } from '../../store/request/loginRequest';




const Navbar = ({ onMenuClick, setLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => openAlert({
    title: 'Konfirmasi', type: 'warning', msg: 'Apakah Anda Yakin Ingin Logout ?', confirmLabel: 'Logout',
    onConfirm: async () => {
      await dispatch(logoutUser());
      navigate('/login', { replace: true });
    },
  });
  const { showAlert } = useAlert(); // Menggunakan hook useAlert
  const [selectedDropdown, setSelectedDropdown] = useState('');
  const employeeName = useSelector((state) => state.auth.userData?.employee_name) || '';
  const group = useSelector((state) => state.auth.group);
  const menu_program = useSelector((state) => state.auth.menu_program) || [];
  const masterPrograms = menu_program.filter(program => program.programtype_id === 1);
  const transactionPrograms = menu_program.filter(program => program.programtype_id === 2);
  const reportPrograms = menu_program.filter(program => program.programtype_id === 3);

;

  const menuItems = [
    {
      id: 'master',
      text: 'Master',
      icon: <MenuIcon category="master" />,
      children: masterPrograms.map(program => ({
        id: `master-${program.program_id}`,
        icon: <MenuIcon program={program.program_ns} />,
        text: program.program_title,
        program_ns: program.program_ns,
        program_instance: program.program_instance,
      }))
    },
    {
      id: 'transaction',
      text: 'Transaction',
      icon: <MenuIcon category="transaction" />,
      children: transactionPrograms.map(program => ({
        id: `transaction-${program.program_id}`,
        icon: <MenuIcon program={program.program_ns} />,
        text: program.program_title,
        program_ns: program.program_ns,
        program_instance: program.program_instance,
      }))
    },
    {
      id: 'report',
      text: 'Report',
      icon: <MenuIcon category="report" />,
      children: reportPrograms.map(program => ({
        id: `report-${program.program_id}`,
        icon: <MenuIcon program={program.program_ns} />,
        text: program.program_title,
        program_ns: program.program_ns,
        program_instance: program.program_instance,
      }))
    }
  ];

  const handleDropdownChange = async (event) => {
    const value = event.target.value;
    console.log('Dropdown changed:', value);
    setSelectedDropdown(value);
    setLoading(true);
    // setloadingMessage('Loading...');



    try {
      const data = await apiRequest('/dashboard/program?id=' + value, 'GET', null);

      setLoading(false);
      // setloadingMessage('x');
      if (data.status === 1) {
        dispatch(updateMenuProgram(Array.isArray(data.data) ? data.data : []));
        // const user = data.data.user;
        // const token = data.data.user.token;
        // const group = data.data.group;
        // const group_pertama = data.data.group_pertama;
        // const menu_program = data.data.program_default;
        //dispatch(loginSuccess({ user, token, group_pertama, group, menu_program }));
      } else {
        showAlert("Error", "error", data.message);
      }

      return data;

    } catch (error) {
      console.error('Error:', error);
      //dispatch(loginFailure('Terjadi kesalahan. Silakan coba lagi.'));
      return { error: true, status: 0, message: 'Terjadi kesalahan. Silakan coba lagi.' };
    } finally {
      setLoading(false);
      // setloadingMessage('x');
    }



  };



  const handleNodeClick = (node) => {
    console.log(node);
    onMenuClick(node);
  };


  useEffect(() => {
  }, [group, menu_program]);

  return (
    <Box component="nav" aria-label="Module navigation" className="sap-sidebar" sx={{ overflowY: 'auto', overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Box className="sap-sidebar-brand" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src={logo} alt="Lemo Crane" />
      </Box>
      <Box className="sap-sidebar-account">
        <AccountCircleOutlinedIcon className="sap-sidebar-avatar" />
        <Box className="sap-sidebar-identity">
          <span className="sap-sidebar-user" title={employeeName}>{employeeName}</span>
          <span className="sap-sidebar-role">{group?.find((item) => String(item.group_id) === selectedDropdown)?.group_name || group?.[0]?.group_name || ''}</span>
        </Box>
        <button type="button" className="sap-sidebar-logout" title="Logout" aria-label="Logout" onClick={handleLogout}><LogoutOutlinedIcon /></button>
      </Box>
      <FormControl className="sap-sidebar-group" fullWidth size="small">
        <Form.Select
          value={selectedDropdown}
          onChange={handleDropdownChange}
          aria-label="Group select"
          className="custom-select"  // Menggunakan kelas CSS khusus
          style={{ width: '150px' }}
        >
          {group && group.length > 0 ? (
            group.map((grp, index) => (
              <option key={index} value={grp.group_id} className="custom-select-option">
                {grp.group_name}
              </option>
            ))
          ) : (
            <option value="">No options available</option>
          )}
        </Form.Select>
      </FormControl>


      <div style={{ padding: '0px' }}></div>
      <div className="sap-sidebar-section-title">WORKSPACE</div>
      <SimpleTreeView>
        {menuItems.map(item => (
          <TreeItem
            key={item.id}
            itemId={item.id}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '0.8em', fontWeight: 'bold', fontFamily: 'verdana' }}>
                {item.icon}
                <Box sx={{ ml: 1 }}>{item.text}</Box>
              </Box>
            }
          >
            {item.children.map(child => (
              <TreeItem
                key={child.id}
                itemId={child.id}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '0.7em', fontFamily: 'verdana' }}>
                    {child.icon}
                    <Box sx={{ ml: 1 }}>{child.text}</Box>
                  </Box>
                }
                onDoubleClick={() => handleNodeClick(child)}
              />
            ))}
          </TreeItem>
        ))}
      </SimpleTreeView>
    </Box>
  );
};

export default Navbar;






